import { render, staticRenderFns } from "./AbacusImporterLogsTable.vue?vue&type=template&id=2bc6a7a0&scoped=true"
import script from "./AbacusImporterLogsTable.vue?vue&type=script&lang=js"
export * from "./AbacusImporterLogsTable.vue?vue&type=script&lang=js"
import style0 from "./AbacusImporterLogsTable.vue?vue&type=style&index=0&id=2bc6a7a0&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc6a7a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDataTable,VIcon})
